export default function({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 167.83 200.2"
    >
      <path
        d="M107.76,175.42c.3-1.92.38-141,.09-144L36.93,48.28v98L.43,160.58l-.21-.11s-.12-.1-.13-.15A10.38,10.38,0,0,1,0,159.21V40.46a3.56,3.56,0,0,1,1.86-1Q54,20,106.05.48A5.38,5.38,0,0,1,109.68.2q28.59,8.3,57.2,16.49c.28.08.56.18,1,.31V184c-5.48,1.52-10.9,3-16.33,4.54-13.83,3.82-27.67,7.6-41.49,11.44a5.88,5.88,0,0,1-3.86-.14Q54.91,180.87,3.65,162a4.48,4.48,0,0,1-1.9-1.14q53,7.29,106,14.55Z"
        fill="#dc3e15"
      />
    </svg>
  )
}
